import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Link,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { logoutUser, acceptTC } from "store/user/user.action";
import { toast } from "react-toastify";
import { VehicleBiddingApi } from "store/vehicleBidding.api";

const TCPopup = () => {
  const [open, setOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleShowPopup = (e) => {
      setOpen(true);
      setCurrentUser(e.detail);
    };

    window.addEventListener('show-tc-popup', handleShowPopup);
    
    return () => {
      window.removeEventListener('show-tc-popup', handleShowPopup);
    };
  }, []);

  const handleLogout = () => {
    try {
      // resets VehicleBiddingAPI's state and caches.
      dispatch(VehicleBiddingApi.util.resetApiState());
      dispatch(logoutUser());
      navigate("/login");
      toast.error(
        "You need to accept to our Terms of Services to continue using our platform."
      );
    } catch (error) {
      console.log(`error with logout - ${error}`);
    }
  };

  const handleClose = () => {
    setOpen(false);
  }

  const handleAccept = async () => {
    if (!isChecked) {
      toast.warning("You must agree to the Terms of Services to continue");
      return;
    }

    setDisableButton(true);
    
    // Here you would add API call to update user's acceptance status
    // For example: updateUserTermsAcceptance(userId, true)
    let result = await dispatch(acceptTC(currentUser.UserId));
    if (result.payload && result.payload.length >= 1 && result.payload[0].data) {
      toast.success("Thank you for accepting our Terms of Services");
      handleClose();
    }
    else {
      toast.error("An unknown error occured, please try again");
      setDisableButton(false);
    }
  };

  // Only allow close from button clicks, not from backdrop or escape key
  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return; // Do nothing, preventing close
    }
    handleClose();
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleDialogClose}
      aria-labelledby="tc-popup-title"
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown={true}
    >
      <DialogTitle id="tc-popup-title">Please review our Terms of Services</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 1 }}>
          <Typography variant="body1" paragraph>
            We have updated our Terms of Services. To continue using our services, you need to review and agree to our updated <Link href="/terms" target="_blank" rel="noopener noreferrer">Terms of Services</Link>.
          </Typography>
          
          <Box sx={{ mt: 3, border: '1px solid #e0e0e0', borderRadius: 1, p: 2, bgcolor: '#f9f9f9' }}>
            <FormControlLabel
              control={
                <Checkbox 
                  checked={isChecked} 
                  onChange={handleCheckboxChange} 
                  color="primary" 
                  required
                />
              }
              label={
                <Typography variant="body2">
                  I have read and agree to the Terms of Services
                </Typography>
              }
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleLogout}>
          Cancel
        </Button>
        <Button
          variant="contained"
          size="medium"
          sx={{ color: "white", fontWeight: 700 }}
          onClick={handleAccept}
          disabled={!isChecked || disableButton}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TCPopup;